<template>
  <div id="app">
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <header :style="{ backgroundColor: empresa.cor_site_media }">
      <router-link to="/denuncia">
        <img
          :src="empresa.arquivo_logo"
          alt="logo"
          style="height: 15vh"
        />
      </router-link>
    </header>

    <router-view />

    <div class="button-wrapper" :style="{ backgroundColor: empresa.cor_site_media }">
      <router-link to="/denuncia/criar-denuncia" class="footer-button" :style="{ backgroundColor: empresa.cor_site_escura }">
        Fazer uma nova denúncia
      </router-link>
      <router-link to="/denuncia/acompanhar-denuncia" class="footer-button" :style="{ backgroundColor: empresa.cor_site_escura }">
        <p id="b1">Acompanhar uma denúncia<br>(é necessário possuir um protocolo)</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import { tratamento_requisicao } from "../../utils/util";
import axios from "axios";
export default {
	data() {
		return {
      isLoading: false,
      empresa: {
        arquivo_logo: '',
        cor_site_escura: '',
        cor_site_media: '',
        cor_site_clara: '',
      }
		};
	},

  created() {
    this.isLoading = true
    let subUrl = window.location.hostname
    subUrl = subUrl.split('.')

    axios.get(`show_by_subdominio/${subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.empresa = res.data
        this.empresa.arquivo_logo = axios.defaults.baseURL.slice(0, -3) + 'arquivos_logo/' + this.empresa.arquivo_logo
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  }
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 62vh;
}

header {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: 24vh;
  margin-top: -56px;
  padding: 5vh;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

#b1 {
  color: #ffffff;
  font-size: 3vh;
  margin-bottom: 0px;
  line-height: 1;
}

.footer-button {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 50%;
  height: 12vh;
  margin: 1vh;
  padding: 3vh;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 4vh;
  cursor: pointer;
}

a:not(.md-button):hover {
  text-decoration: none;
}

@media (max-width: 374px) {
  #b1 {
    font-size: 1.2vh;
  }

  .footer-button {
    padding: 1vh;
    font-size: 2vh;
  }
}

@media (min-width: 375px) and (max-width: 576px) {
 #b1 {
    font-size: 1.3vh;
  }

  .footer-button {
    padding: 1vh;
    font-size: 2vh;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  #b1 {
    font-size: 1.8vh;
  }

  .footer-button {
    padding: 2vh;
    font-size: 2.5vh;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  #b1 {
    font-size: 2vh;
  }

  .footer-button {
    padding: 2vh;
    font-size: 3vh;
  }
}

@media (min-width: 993px) and (max-width: 1200px) {
  #b1 {
    font-size: 3vh;
  }

  .footer-button {
    padding: 2vh;
    font-size: 3.5vh;
  }
}
</style>